import React from 'react'

const datatable = {
    deposit: [
        {
            title: 'SN.',
            dataIndex: 'serial',
            key: 'serial'
        },
        {
            title: 'Date & Time',
            dataIndex: 'time',
            key: 'time',
            width: '200'
        },
        {
            title: 'From',
            dataIndex: 'fromm',
            key: 'from'
        },
        {
            title: 'To',
            dataIndex: 'too',
            key: 'to'
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount'
        },
        {
            title: 'Return',
            dataIndex: 'return',
            key: 'return'
        },
        {
            title: 'Method',
            dataIndex: 'method',
            key: 'method'
        },
        // {
        //     title: 'Refer',
        //     dataIndex: 'refer',
        //     key: 'refer'
        // },
        {
            title: 'Image',
            dataIndex: 'depo_img',
            key: 'depo_img'
        },
        {
            title: 'Action',
            dataIndex: 'action_time',
            key: 'action_time'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            fixed: 'right'
        }
    ],
    withdraw: [
        {
            title: 'SN.',
            dataIndex: 'serial',
            key: 'serial'
        },
        {
            title: 'Date & Time',
            dataIndex: 'time',
            key: 'time'
        },
        {
            title: 'To',
            dataIndex: 'too',
            key: 'too'
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount'
        },
        {
            title: 'Return',
            dataIndex: 'return',
            key: 'return'
        },
        {
            title: 'Rate',
            dataIndex: 'rate',
            key: 'rate'
        },
        {
            title: 'Method',
            dataIndex: 'method',
            key: 'method'
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes'
        },
        {
            title: 'From',
            dataIndex: 'con_number',
            key: 'con_number'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            fixed: 'right'
        }
    ],
    transection: [
        {
            title: 'SN.',
            dataIndex: 'serial',
            key: 'serial'
        },
        {
            title: 'Date & Time',
            dataIndex: 'time',
            key: 'time'
        },
        {
            title: 'Detail',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Debit',
            dataIndex: 'debit',
            key: 'debit'
        },
        {
            title: 'Credit',
            dataIndex: 'credit',
            key: 'credit'
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            fixed: 'right'
        },
        {
            title: 'Cashback',
            dataIndex: 'bonus',
            key: 'bonus',
        },
    ],
    work: [
        {
            title: 'SN.',
            dataIndex: 'serial',
            key: 'serial'
        },
        {
            title: 'Date & Time',
            dataIndex: 'time',
            key: 'time'
        },
        {
            title: 'Game',
            dataIndex: 'work',
            key: 'work'
        },
        {
            title: 'Match',
            dataIndex: 'match',
            key: 'match',
            width: 200
        },
        {
            title: 'Option',
            dataIndex: 'option',
            key: 'option'
        },
        {
            title: 'Target',
            dataIndex: 'target',
            key: 'target'
        },
        {
            title: 'Rate',
            dataIndex: 'betRate',
            key: 'betRate'
        },
        {
            title: 'Amount',
            dataIndex: 'betAmount',
            key: 'betAmount'
        },
        {
            title: 'Return',
            dataIndex: 'return',
            key: 'return'
        },
        {
            title: 'Action Time',
            dataIndex: 'actionAt',
            key: 'actionAt'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            fixed: 'right'
        }
    ],
    send_coin: [
        {
            title: 'SN.',
            dataIndex: 'serial',
            key: 'serial'
        },
        {
            title: 'Date & Time',
            dataIndex: 'time',
            key: 'time'
        },
        {
            title: 'From',
            dataIndex: 'from_idd',
            key: 'from_idd'
        },
        {
            title: 'To',
            dataIndex: 'to_idd',
            key: 'to_idd'
        },
        {
            title: 'Interest',
            dataIndex: 'interest',
            key: 'interest'
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            fixed: 'right'
        }
    ]
}

export default datatable;